import LocationList from './LocationList';

export default LocationList;
